module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_3016.0035a6a9.png";